import { useEffect, useState } from "react";
import { BREAKPOINTS } from "../constants/styles";

const useBreakpoints = () => {
  const [currentBreakpoint, setCurrentBreakpoint] = useState<string | null>(
    null
  );

  useEffect(() => {
    const checkBreakpoint = () => {
      const width = window.innerWidth;

      let breakpointType = "";

      switch (true) {
        case width <= BREAKPOINTS.MOBILE.resolution:
          breakpointType = BREAKPOINTS.MOBILE.type;
          break;
        case width <= BREAKPOINTS.TABLET.resolution:
          breakpointType = BREAKPOINTS.TABLET.type;
          break;
        case width <= BREAKPOINTS.SMALL_DESKTOP.resolution:
          breakpointType = BREAKPOINTS.SMALL_DESKTOP.type;
          break;
        case width <= BREAKPOINTS.MEDIUM_DESKTOP.resolution:
          breakpointType = BREAKPOINTS.MEDIUM_DESKTOP.type;
          break;
        case width <= BREAKPOINTS.LARGE_DESKTOP.resolution:
          breakpointType = BREAKPOINTS.LARGE_DESKTOP.type;
          break;
        case width <= BREAKPOINTS.TV.resolution:
          breakpointType = BREAKPOINTS.TV.type;
          break;
        default:
          breakpointType = BREAKPOINTS.LARGE_RESOLUTION.type;
      }

      setCurrentBreakpoint(breakpointType);
    };

    checkBreakpoint();

    window.addEventListener("resize", checkBreakpoint);

    return () => window.removeEventListener("resize", checkBreakpoint);
  }, []);

  return currentBreakpoint;
};

export default useBreakpoints;
